import Alert from '@mui/material/Alert';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import { hasPermission } from '@relif/zeller-roles';
import useCurrentUser from 'hooks/useCurrentUser';
import { type FC, useEffect, useState } from 'react';
import { useAssignClientToUserMutation, useGetAssignableUsersMutation } from 'services/api/user.api';
import type { Client } from 'services/types/client';

interface Props {
  client: Client;
}

const UserAssigner: FC<Props> = ({ client }) => {
  const [selectedUserId, setSelectedUserId] = useState<number | null>(client.userId || null);

  const currentUser = useCurrentUser();
  const [getAssignableUsers, { data: assignableUsers }] = useGetAssignableUsersMutation();
  const [assignClientToUser, { isError: isErrorAssignClientToUser }] = useAssignClientToUserMutation();

  useEffect(() => {
    if (currentUser && hasPermission(currentUser, 'clients', 'assign', client)) {
      getAssignableUsers(client.id).catch((error) => {
        console.error(error);
      });
    }
  }, [client.id]);

  useEffect(() => {
    if (selectedUserId && selectedUserId !== client.userId) {
      assignClientToUser({ userId: selectedUserId, clientToAssignId: client.id }).catch((error) => {
        console.error(error);
      });
    }
  }, [selectedUserId]);

  if (!assignableUsers?.assignableUsers) {
    return <Typography>No hay usuarios disponibles para asignar</Typography>;
  }

  if (isErrorAssignClientToUser) {
    return <Alert severity="error">Error al asignar el cliente al usuario</Alert>;
  }

  return (
    <FormControl fullWidth>
      <InputLabel id="user-select-label">Usuario</InputLabel>
      <Select
        label="Usuario"
        variant="outlined"
        onChange={(e) => setSelectedUserId(Number(e.target.value))}
        value={selectedUserId || ''}
        autoWidth
      >
        {assignableUsers.assignableUsers?.map((user) => (
          <MenuItem key={user.id} value={user.id}>
            <Typography
              sx={{
                fontWeight: 500,
              }}
            >
              {user.name}
            </Typography>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default UserAssigner;
